import { render, staticRenderFns } from "./questionTitle.vue?vue&type=template&id=d7061be2&scoped=true"
import script from "./questionTitle.vue?vue&type=script&lang=js"
export * from "./questionTitle.vue?vue&type=script&lang=js"
import style0 from "./questionTitle.vue?vue&type=style&index=0&id=d7061be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7061be2",
  null
  
)

export default component.exports